export enum RequestStatus {
    Approved = "RequestStatus.Approved",
    Pending = "RequestStatus.Pending",
    Denied = "RequestStatus.Denied",
    Cancelled = "RequestStatus.Cancelled"
}